var app = angular.module('leonardo');

var WorkFlowUnitSelectDialog = function ($scope, $timeout, $controller, $q, UnitService, UnitTypeService, FilterService, WorkFlowService) {
  $scope.property = $scope.fromwf ? $scope.data.properties_data.properties : $scope.ngDialogData.property;
  if(!$scope.fromwf) {
    $scope.workflowId = $scope.ngDialogData.workflowId ? $scope.ngDialogData.workflowId : $scope.ngDialogData.workflow.id;
    $scope.portfolio = $scope.ngDialogData.portfolio;
    $scope.account = $scope.ngDialogData.account;
    $scope.actionName = $scope.ngDialogData.actionName;
    $scope.actionButton = $scope.ngDialogData.actionButton;
    $scope.filter_conditions = [];
  }
  $scope.units = [];
  $scope.unitsLeft = [];
  $scope.unitsRight = [];
  $scope.unit_types = [];
  $scope.unit_selected = ($scope.action === 'edit' && $scope.fromwf) ? $scope.unit_selected : [];
  $scope.unit_number = '';
  $scope.building_number = '';
  $scope.unitTypeService = UnitTypeService;
  $scope.WorkFlowService = WorkFlowService;
  $scope.all = ($scope.action === 'edit' && $scope.fromwf) ? $scope.all : false;
  $scope.units_exclude = ($scope.action === 'edit' && $scope.fromwf) ? $scope.units_exclude : [];
  $scope.tableFilterSize = 10;
  $scope.selections = 0;
  $scope.order = ($scope.fromwf || $scope.actionButton === 'massLaunch' ) ? 'property_name' : null;
  $scope.onload = true;
  if($scope.fromwf){
    $scope.submitFromWorkflow = $scope.submit;
  }
  $scope.countUnitSelections = function () {
    const filter_conditions = angular.copy($scope.filter_conditions);

    var condition = {
      units: $scope.all ? 'all' : angular.copy($scope.unit_selected)
    };
    if ($scope.all) {
      condition.unit_filters = {
        number__icontains: FilterService.hasFilter('unit_number') ? FilterService.getFilter('unit_number') : null,
        building__icontains: FilterService.hasFilter('building_number') ? FilterService.getFilter('building_number') : null,
        unit_type: FilterService.hasFilter('unit_type') ? FilterService.getFilter('unit_type') : null
      };
      if ($scope.units_exclude.length > 0) {
        condition.units_exclude = angular.copy($scope.units_exclude);
      }
      if (FilterService.hasFilter('unit_type')) {
          UnitTypeService.getlist({ id: FilterService.getFilter('unit_type') }).then(function (data) {
            var results = data && data.results ? data.results : data;
            $scope.unit_types = $scope.unit_types.concat(results);
          });
      }
    }
    filter_conditions.push(condition);

    angular.forEach(filter_conditions, function (filtercondition) {
      filtercondition.units = angular.isArray(filtercondition.units) ? filtercondition.units.map((item) => item.id) : filtercondition.units;
      if (filtercondition.units_exclude) {
        filtercondition.units_exclude = filtercondition.units_exclude.map((item) => item.id);
      }
    });
    var params = {
      property: $scope.fromwf ? $scope.data.properties_data ? $scope.data.properties_data.properties : [] : $scope.property,
      filter_conditions
    };

    if($scope.actionButton === "massLaunch" || $scope.fromwf){
      WorkFlowService.multiPropertyCountSelectedUnits($scope.workflowId, params).then(function (data) {
        $scope.selections = data.results.unit_count
      }, function () {
        // This is intentional do_something blank function
      });
    }else{
      WorkFlowService.countSelectedUnits($scope.workflowId, params).then(function (data) {
        $scope.selections = data.results.unit_count
      }, function () {
        // This is intentional do_something blank function
      });
    }
  };

  $scope.getUnitTypeLabel = function (unit_type_id) {
    var unit_type = $scope.unit_types.find((item) => item.id.toString() === unit_type_id.toString());
    return unit_type ? unit_type.name : '';
  };

  $scope.getlabelFilterCondition = function (condition) {
    var label = '';
    if (condition.units === 'all') {
      var number = condition.unit_filters.number__icontains;
      var building = condition.unit_filters.building__icontains;
      var unit_type = condition.unit_filters.unit_type;
      label += 'Select All ';
      if (number || building || unit_type) {
        label += 'of ';
      }
      if (number) {
        label += 'Number: "' + number + '" ';
      }
      if (building) {
        label += 'Building: "' + building + '" ';
      }
      if (unit_type) {
        label += 'Type: "' + $scope.getUnitTypeLabel(unit_type) + '" ';
      }
      if (condition.units_exclude && condition.units_exclude.length > 0) {
        var excludes = condition.units_exclude.map((item) => item.number);
        label += '- Exlcude: ' + excludes.join(', ');
      }
    } else if (condition.units && condition.units.length > 0) {
      var units = condition.units.map((item) => item.number);
      label += 'Units: ' + units.join(', ');
    }
    return label;
  };

  $scope.addFilterCondition = function (submit) {
    if (!$scope.all && $scope.unit_selected.length === 0) {
      return;
    }
    var condition = {
      units: $scope.all ? 'all' : angular.copy($scope.unit_selected)
    };
    if ($scope.all) {
      condition.unit_filters = {
        number__icontains: FilterService.hasFilter('unit_number') ? FilterService.getFilter('unit_number') : null,
        building__icontains: FilterService.hasFilter('building_number') ? FilterService.getFilter('building_number') : null,
        unit_type: FilterService.hasFilter('unit_type') ? FilterService.getFilter('unit_type') : null
      };
      if ($scope.units_exclude.length > 0) {
        condition.units_exclude = angular.copy($scope.units_exclude);
      }
      if (!submit && FilterService.hasFilter('unit_type')) {
        UnitTypeService.getlist({ id: FilterService.getFilter('unit_type') }).then(function (data) {
          var results = data && data.results ? data.results : data;
          $scope.unit_types = $scope.unit_types.concat(results);
        });
      }
    }
    if (!submit){
      condition.isMarked = true;
    }
    else {
      condition.isMarked = false;
    }
    $scope.filter_conditions.push(condition);
    $timeout(function () {
      $scope.all = false;
      $scope.unit_selected = [];
      $scope.units_exclude = [];
      $scope.countUnitSelections();
      $scope.unit_number = '';
      $scope.building_number = '';
      if($scope.fromwf){
        $scope.data.unit_number = '';
        $scope.data.building_number = '';
      }
      FilterService.removeFilter('unit_type');
      $scope.search();
    });
  };

  $scope.deleteCondition = function (index) {
    $scope.filter_conditions.splice(index, 1);
    $scope.countUnitSelections()
  };

  $scope.search = function () {
    let unit_number = $scope.fromwf ? $scope.data.unit_number : $scope.unit_number;
    let building_number = $scope.fromwf ? $scope.data.building_number : $scope.building_number;
    FilterService.setFilter('unit_number', unit_number);
    FilterService.setFilter('building_number', building_number);
    $scope.loadPage(1);
  };

  $scope.isSelected = function (unit) {
    var excludes = $scope.units_exclude.map((item) => item.id.toString());
    var selected = $scope.unit_selected.map((item) => item.id.toString());
    return ($scope.all || _.contains(selected, unit.id.toString())) && !_.contains(excludes, unit.id.toString());
  };

  $scope.selectUnit = function (unit) {
    var excludes = $scope.units_exclude.map((item) => item.id);
    var selected = $scope.unit_selected.map((item) => item.id);
    if ($scope.all) {
      if (_.contains(excludes, unit.id)) {
        $scope.units_exclude.splice(excludes.indexOf(unit.id), 1);
      } else {
        $scope.units_exclude.push(unit);
      }
    } else {
      if (_.contains(selected, unit.id)) {
        $scope.unit_selected.splice(selected.indexOf(unit.id), 1);
      } else {
        $scope.unit_selected.push(unit);
      }
    }
    $scope.countUnitSelections();
  };

  $scope.selectAll = function () {
    if ($scope.units.length === 0) {
      return;
    }
    $scope.all = !$scope.all;
    $scope.unit_selected = [];
    $scope.units_exclude = [];
    $scope.countUnitSelections()
  };

  $scope.getParams = function () {
    var params = {
      property: $scope.fromwf ? $scope.data.properties_data ? $scope.data.properties_data.properties : [] : $scope.property
    };
    params['number__icontains'] = FilterService.getFilter('unit_number');
    params['building__icontains'] = FilterService.getFilter('building_number');
    params['unit_type'] = FilterService.getFilter('unit_type');
    return params;
  };

  $scope.getEntitiesPromise = function (options, noCancel) {
    if($scope.onload && $scope.fromwf && $scope.action == 'edit'){
      FilterService.setFilter('unit_number', $scope.data.unit_number);
      FilterService.setFilter('building_number', $scope.data_building_number);
      FilterService.setFilter('unit_type', $scope.data.unit_type);
    }
    var params = $scope.getParams();
    angular.forEach(params, function (value, key) {
      options[key] = value;
    });
    var defer = $q.defer();
    if($scope.actionButton === "massLaunch" || $scope.fromwf){
      $scope.onload = false;
      if(params.property && params.property.length > 0){
        if (options.limit === null) {
          delete options.limit;
        }
        UnitService.getUnitOnBasisOfMultipleProperty(options, noCancel)
        .then(
          function (data) {
          $scope.units = data.results ? data.results : data;
          // for removing the selected units if its not exist in selected property
          if($scope.fromwf){
            $scope.unit_selected = !$scope.all ? $scope.unit_selected.filter(data => $scope.propertiesList.includes(data.property)) : $scope.unit_selected;
            angular.forEach($scope.filter_conditions, function (condition) {
              condition.units = angular.isArray(condition.units) ? condition.units.filter(data => $scope.propertiesList.includes(data.property)) : condition.units;
              if (condition.units_exclude) {
                condition.units_exclude = condition.units_exclude.filter(data => $scope.propertiesList.includes(data.property));
                if(condition.units_exclude.length == 0) delete condition.units_exclude;
              }
            });
            $scope.filter_conditions = $scope.filter_conditions.filter(condition =>{
               return ((angular.isArray(condition.units) && condition.units.length != 0) || (!angular.isArray(condition.units)))
            })
            $scope.countUnitSelections();
          }
          if ($scope.units.length) {
            var elementsLeft = Math.round($scope.units.length/2)
            $scope.unitsRight = angular.copy($scope.units)
            $scope.unitsLeft = $scope.unitsRight.splice(0, elementsLeft);
            if (!$scope.units.meta) {
              $scope.units['meta'] = {
                previous: data.previous,
                next: data.next,
                count: data.count
              };
            }
          }
          defer.resolve($scope.units);
        },
      function (error) {
        defer.reject(error);
      });
      }
      else {
        $scope.units = [];
        $scope.unitsRight = [];
        $scope.unitsLeft = [];
        $scope.unit_selected = [];
        $scope.units_exclude = [];
        $scope.filter_conditions = [];
        $scope.countUnitSelections();
        defer.resolve($scope.units);
      }
    }else{
      UnitService.getlist(options, noCancel).then(
        function (data) {
          $scope.units = data.results ? data.results : data;
          if ($scope.units.length) {
            var elementsLeft = Math.round($scope.units.length/2)
            $scope.unitsRight = angular.copy($scope.units)
            $scope.unitsLeft = $scope.unitsRight.splice(0, elementsLeft);
          }
          defer.resolve($scope.units);
        },
        function (error) {
          defer.reject(error);
        }
      );
    }
    
    return defer.promise;
  };

  
  $scope.submit = function () {
    if($scope.fromwf){
     $scope.addFilterCondition(true);
     $scope.submitFromWorkflow();
    }
    else{
      $scope.Form.$setSubmitted();
      $scope.addFilterCondition(true);
      if ($scope.filter_conditions.length === 0) {
        return;
      }
      angular.forEach($scope.filter_conditions, function (condition) {
        condition.units = angular.isArray(condition.units) ? condition.units.map((item) => item.id) : condition.units;
        if (condition.units_exclude) {
          condition.units_exclude = condition.units_exclude.map((item) => item.id);
        }
      });
      $scope.confirm($scope.filter_conditions);
    }
  };

  $controller('TableFilterController', { $scope: $scope });

  $scope.$on('unit:updated', function (event, noCancel) {
    $scope.loadPage($scope.page, noCancel);
  });
  $scope.$on('unit:created', function (event, noCancel) {
    $scope.loadPage($scope.page, noCancel);
  });

  $scope.loadPage($scope.page);

  $scope.$on('$destroy', function () {
    FilterService.clearFilters(true);
  });
};

app.controller('WorkFlowUnitSelectDialog', [
  '$scope',
  '$timeout',
  '$controller',
  '$q',
  'UnitService',
  'UnitTypeService',
  'FilterService',
  'WorkFlowService',
  WorkFlowUnitSelectDialog
]);
